module.exports = __webpack_public_path__ + "static/media/dashboard.c9d460d4.svg";